import { api } from '../utils/api';
import type { User } from '../types/@types/user';

export async function getUser(id: string): Promise<User> {
  const { data } = await api.get<User>(`/users/${id}`);
  return data;
}

export async function updateUser(id: string, user: Partial<Omit<User, 'id'>>): Promise<User> {
  const { data } = await api.put<User>(`/users/${id}`, user);
  return data;
}

export async function uploadAvatar(id: string, file: File): Promise<User> {
  const formData = new FormData();
  formData.append('avatar', file);
  const { data } = await api.post<User>(`/users/${id}/avatar`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function changePassword(id: string, password: string): Promise<void> {
  await api.post(`/users/${id}/change-password`, { password });
}
